import Players from "../../LeagueManagement/Player/Public/PlayerListPublic.jsx";
import Standings from "../../LeagueManagement/Standing/StandingDefault.jsx";
import Schedule from "../../LeagueManagement/Schedule/Public/SchedulePublic.jsx";
import Leaderboard from "../../LeagueManagement/Leaderboard/Leaderboard.jsx";
import TournamentBracket from "../../LeagueManagement/Tournament/Public/TournamentBracket.jsx";

const systemPageRegistry = {
 players: {
  key: "players",
  label: "Players",
  publicComponent: Players,
 },

 standings: {
  key: "standings",
  label: "Standings",
  publicComponent: Standings,
 },

 schedule: {
  key: "schedule",
  label: "Schedule",
  publicComponent: Schedule,
 },

 leaderboard: {
  key: "leaderboard",
  label: "Leaderboard",
  publicComponent: Leaderboard,
 },

 tournament_bracket: {
  key: "tournament_bracket",
  label: "Tournament Bracket",
  publicComponent: TournamentBracket,
 },
};

export default systemPageRegistry;